import { Stack, useTheme } from "@mui/material";
import type { FC } from "react";
import { SabSkeleton } from "web_myplann/Shared/Skeletons";

type Props = {
	isLast: boolean;
};

export const CalculatorListSkeletonRow: FC<Props> = ({ isLast }) => {
	const theme = useTheme();

	return (
		<Stack
			direction="row"
			alignItems="center"
			gap={theme.spacingTokens.md}
			px={theme.spacingTokens.lg}
			py={theme.spacingTokens.md}
			borderBottom={
				isLast ? "none" : theme.colors.border.solid(theme.palette.grey[100])
			}
		>
			<SabSkeleton
				variant="rectangular"
				width={40}
				height={40}
				borderRadius={theme.radii.lg}
			/>
			<Stack flex={1} gap={theme.spacingTokens.xs}>
				<SabSkeleton variant="text" width="40%" height={14} />
				<SabSkeleton variant="text" width="70%" height={12} />
			</Stack>
		</Stack>
	);
};
